import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '32px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#dc2626', marginBottom: '12px', fontSize: '20px' }}>
            Terjadi Error
          </h2>
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '12px',
            padding: '16px', marginTop: '16px', textAlign: 'left', maxWidth: '600px', margin: '16px auto'
          }}>
            <p style={{ fontWeight: 600, color: '#991b1b', marginBottom: '8px' }}>{this.state.error?.message}</p>
            <pre style={{
              fontSize: '12px', color: '#7f1d1d', whiteSpace: 'pre-wrap',
              maxHeight: '200px', overflow: 'auto', background: '#fee2e2',
              padding: '12px', borderRadius: '8px'
            }}>
              {this.state.error?.stack}
            </pre>
            {this.state.errorInfo?.componentStack && (
              <details style={{marginTop:'12px',textAlign:'left'}}>
                <summary style={{cursor:'pointer',fontWeight:600,color:'#991b1b',fontSize:'13px'}}>📍 Component Stack</summary>
                <pre style={{fontSize:'11px',color:'#7f1d1d',whiteSpace:'pre-wrap',background:'#fee2e2',padding:'12px',borderRadius:'8px',marginTop:'8px',maxHeight:'200px',overflow:'auto'}}>
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px', padding: '10px 24px', background: '#2563eb',
              color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px'
            }}
          >
            🔄 Reload Halaman
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
